import React, { useState } from "react";
import ToggleLinks from "../../../../parts/inputs/toggle-links-input";
import ButtonSwitch from "../../../../parts/buttonSwitch";
const unitOptions = [
  { name: "Summary", value: "sum" },
  { name: "History", value: "hy" },
  { name: "Report", value: "rep" },
];
const Navs = () => {
  const [selectedOption, setSelectedOption] = useState(unitOptions[0]);
  return (
    <div className="flex flex-col gap-2">
      <div class="max-w-fit bg-[--white-10] p-4 rounded-md mb-2">Tablist</div>
      {/* This one is TablistNav component */}
      <nav role="tablist">
        <a role="tab" href="#" aria-current="true">
          All
        </a>
        <a href="#" role="tab" data-status="active">
          Active
        </a>
        <a href="#" role="tab" data-status="inactive">
          Inactive
        </a>
      </nav>
      <nav role="tablist">
        <a
          aria-current="true"
          href="/athlete-portal/profile?section=dashboard&amp;athlete=61fd6e32061bed1f003a90fd"
        >
          Dashboard
        </a>
        <a href="/athlete-portal/profile?section=questionnaire&amp;athlete=61fd6e32061bed1f003a90fd">
          Check-in Questionnaire
        </a>
        <a href="/athlete-portal/profile?section=accountability&amp;athlete=61fd6e32061bed1f003a90fd">
          Daily Accountability
        </a>
        <a href="/athlete-portal/profile?section=tasks&amp;athlete=61fd6e32061bed1f003a90fd">
          Tasks
        </a>
        <a href="/athlete-portal/profile?section=guides&amp;athlete=61fd6e32061bed1f003a90fd">
          Guides
        </a>
      </nav>
      <h4 className="mt-4">Toggle Links component</h4>
      <ToggleLinks
        className="alt"
        name="reports"
        options={[
          { text: "Royalties", value: "royalties" },
          { text: "Sales Tax", value: "sales_tax" },
          {
            text: "Coaches",
            value: "coaches",
          },
          {
            text: "Push Coaches",
            value: "pushCoaches",
          },
        ]}
      />
      <h4 className="mt-4">Button Switch</h4>
      <ButtonSwitch
        options={unitOptions}
        selectedOption={selectedOption}
        onClickFn={(opt) => setSelectedOption(opt)}
      />
    </div>
  );
};

export default Navs;
